import { NgModule, ModuleWithProviders } from '@angular/core'
import { CommonModule } from '@angular/common'
import { HTTP_INTERCEPTORS } from '@angular/common/http'
import { ErrorInterceptor } from './interceptors/error.interceptor'
import { MockInterceptor } from './interceptors/mock.interceptor'

@NgModule({
  imports: [CommonModule],
  declarations: []
})
export class NetworkModule {
  static forRoot(): ModuleWithProviders<NetworkModule> {
    return {
      ngModule: NetworkModule,
      providers: [
        {
          provide: HTTP_INTERCEPTORS,
          useClass: MockInterceptor,
          multi: true
        },
        {
          provide: HTTP_INTERCEPTORS,
          useClass: ErrorInterceptor,
          multi: true
        }
      ]
    }
  }
}
